import React from 'react';
import { MailIcon, HammerIcon } from 'lucide-react';
export function FooterSection() {
  return <footer className="bg-[#0a0a0a] text-gray-400 py-10 md:py-16 px-4" data-id="element-60">
      <div className="max-w-4xl mx-auto" data-id="element-61">
        {/* Brand Section */}
        <div className="text-center mb-8 md:mb-12" data-id="element-62">
          <div className="flex items-center justify-center gap-3 mb-4" data-id="element-63">
            <div className="bg-[#16a34a] p-2.5 rounded-lg" data-id="element-64">
              <HammerIcon className="w-7 h-7 text-white" data-id="element-65" />
            </div>
            <h2 className="text-3xl md:text-4xl font-black text-white tracking-tight" data-id="element-66">
              kit<span className="text-[#16a34a]" data-id="element-67">online</span>
            </h2>
          </div>
          <p className="text-gray-400 text-sm md:text-base max-w-md mx-auto leading-relaxed" data-id="element-68">
            Tu plataforma de recursos digitales para aprender oficios reales.
            Herrería, carpintería y más — todo en un solo lugar.
          </p>
        </div>

        {/* Contact */}
        <div className="text-center mb-8 md:mb-10" data-id="element-69">
          <a href="mailto:kitonline27@gmail.com" className="inline-flex items-center gap-2.5 bg-[#111] border border-gray-800 hover:border-[#16a34a] text-gray-300 hover:text-white px-5 py-3 rounded-lg transition-all duration-200 text-sm md:text-base font-medium" data-id="element-70">
            <MailIcon className="w-4.5 h-4.5 text-[#16a34a]" data-id="element-71" />
            kitonline27@gmail.com
          </a>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-800 pt-6 md:pt-8" data-id="element-72">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-73">
            <p className="text-gray-500 text-xs md:text-sm font-medium" data-id="element-74">
              © 2026 kitonline™ — Todos los derechos reservados
            </p>
            <div className="flex gap-6 text-xs md:text-sm font-semibold uppercase tracking-wider" data-id="element-75">
              <span className="cursor-pointer hover:text-white transition-colors" data-id="element-76">
                Términos
              </span>
              <span className="cursor-pointer hover:text-white transition-colors" data-id="element-77">
                Privacidad
              </span>
              <span className="cursor-pointer hover:text-white transition-colors" data-id="element-78">
                Soporte
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}